__turbopack_context__.v({
  "backdrop": "SettingsDialog-module__v_SSIq__backdrop",
  "content": "SettingsDialog-module__v_SSIq__content",
});
